import { useLayoutStore } from '../store/layoutStore';

/**
 * Clickable panel title with a chevron that toggles a collapse flag stored in
 * the layout store under {@link props.k}. Reused across side panels so they all
 * collapse consistently.
 */
export function CollapseHeader(props: { title: string; k: string }): React.ReactElement {
  const collapsed = useLayoutStore((s) => !!s.collapsed[props.k]);
  const toggle = useLayoutStore((s) => s.toggleCollapsed);
  return (
    <button
      type="button"
      className="panel-title collapse-head"
      onClick={() => toggle(props.k)}
      aria-expanded={!collapsed}
    >
      <span className="chev">{collapsed ? '▸' : '▾'}</span>
      {props.title}
    </button>
  );
}
